import { render, staticRenderFns } from "./WebpagesNew.vue?vue&type=template&id=fc5d2bf8&scoped=true&"
import script from "./WebpagesNew.vue?vue&type=script&lang=js&"
export * from "./WebpagesNew.vue?vue&type=script&lang=js&"
import style0 from "./WebpagesNew.vue?vue&type=style&index=0&id=fc5d2bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5d2bf8",
  null
  
)

export default component.exports